module.exports = __webpack_public_path__ + "img/1588064381.51ce879e.jpg";